import { render, staticRenderFns } from "./stampAndNotice.vue?vue&type=template&id=7a23cc80&"
import script from "./stampAndNotice.vue?vue&type=script&lang=ts&"
export * from "./stampAndNotice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports